module.exports = __webpack_public_path__ + "img/active-block-bg.3beb3dc9.png";